import OpenSeadragon from 'openseadragon'
import navigator from '../navigator'
import ruler from '../ruler'
import multiViewControls from '../multiViewControls'
import layers from './layers'
import loader from '../loader'
import { setupFullscreenButton } from './fullscreen'
import ganalytics from '../ganalytics'
import uiConfiguration from '../uiConfiguration'

function resetSlider(imagesCount) {
  const sliderContainer = document.getElementById('slider-container')
  const classList = ['slider-container1', 'slider-container2', 'slider-container3']
  classList.forEach(c => sliderContainer.classList.remove(c))

  sliderContainer.classList.add(`slider-container${imagesCount}`)
  sliderContainer.querySelector('.slider').value = 0
}

function createViewerDom() {
  const navigatorDom = navigator.createDom()
  const viewer = `	
<div id="viewer" class="viewer layer-viewer" style="width:100%; left:0">
  <div id="slider-container" class="slider-container1">
    <div id="slider-circle-left" class="slider-circle"></div>
    <div id="slider-circle-center" class="slider-circle"></div>
    <input id="slider" type="range" class="slider" step="1" min="0" max="100" value="0">
    <div id="slider-circle-right" class="slider-circle"></div>
  </div>
</div>
${navigatorDom}
`

  const widgetContainer = document.getElementById('widgetContainer')
  widgetContainer.insertAdjacentHTML('beforeend', viewer)
}

function updateImages(state, viewer) {
  const visibleImagesStates = state.filter(state => state.visible)

  if (visibleImagesStates.length > 0) {
    viewer.open(visibleImagesStates[0].tileSources[0])
    visibleImagesStates.slice(1).forEach(data => {
      viewer.addTiledImage({
        tileSource: data.tileSources[0],
        opacity: 0
      })
    })
  } else {
    viewer.open(null)
  }

  resetSlider(visibleImagesStates.length)
}

function init(imagesData, customUIName) {
  createViewerDom()
  const viewer = OpenSeadragon({
    id: 'viewer',
    prefixUrl: 'openseadragon/',
    homeButton: 'home',
    homeFillsViewer: false,
    showNavigator: true,
    navigatorId: 'navigator',
    navigatorHeight: '184px',
    navigatorWidth: '184px',
    ppi: imagesData[0].ppi,
    zoomInButton: 'zoom-in',
    zoomOutButton: 'zoom-out',
    preserveImageSizeOnResize: true,
    loadTilesWithAjax: true,
    gestureSettingsMouse: {
      flickEnabled: false,
      clickToZoom: false,
      dblClickToZoom: true
    },
    animationTime: 1.75,
    maxZoomPixelRatio: imagesData[0].maxZoomPixelRatio,
    rotateRightButton: imagesData[0].canRotate ? 'rotate' : null,
    rotationIncrement: imagesData[0].canRotate ? 45 : 0,
    showRotationControl: true
  })

  imagesData.forEach((imageData, index) => {
    viewer.addTiledImage({
      tileSource: imagesData[index].tileSources[0],
      opacity: index === 0 ? 1 : 0
    })
  })

  const maxValue = 100 * imagesData.length
  const slider = document.querySelector('.slider')
  slider['max'] = maxValue - 1
  slider.oninput = function () {
    const imagesCount = viewer.world.getItemCount()
    const opacities = layers.getOpacity(maxValue, imagesCount)
    const imagesOpacities = Array.from(Array(imagesCount).keys()).map(opacities)

    viewer.world._items.forEach((item, index) => {
      item.setOpacity(imagesOpacities[index][this.value])
    })
  }

  navigator.setup(viewer)
  const rulerDom = document.getElementById('ruler')
  ruler.setupRulerToggleButton(rulerDom)
  ruler.onCanvasClickSetup(viewer, rulerDom)

  multiViewControls.createDom(imagesData)
  resetSlider(imagesData.length)

  const viewerElement = document.getElementById('viewer')
  viewerElement.addEventListener('changeSelectedImage', e => {
    updateImages(e.detail.state, viewer)
    if (e.detail.viewerPosition) {
      viewer.addHandler('open', () => {
        if (e.detail.viewerRotation) {
          viewer.viewport.setRotation(e.detail.viewerRotation)
        }
        viewer.viewport.fitBounds(e.detail.viewerPosition, true)
      })
    }
  })

  viewerElement.addEventListener('updateImagesVisibility', e => {
    updateImages(e.detail.state, viewer)
  })

  setupFullscreenButton(viewer, customUIName)

  let analyticsCustomerCode = uiConfiguration.getConfigurationFor(customUIName, 'analyticsCustomerCode')

  ganalytics.setupAnalyticsCustomButtons(imagesData[0], analyticsCustomerCode)
  ganalytics.setupAnalyticsForOpenSeaDragon(viewer, imagesData[0], analyticsCustomerCode, true)

  return [viewer]
}

export default { init }
